var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarGirl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "95px",
    height: "113px",
    viewBox: "-20 -15 130 113",
    style: {
      enableBackground: "new 0 0 95 113"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#9D6E48;}\r\n\t.st1{fill:#8D5F3D;}\r\n\t.st2{fill:#F6B47B;}\r\n\t.st3{fill:#E2A071;}\r\n\t.st4{fill:#FDC88E;}\r\n\t.st5{fill:#623F33;}\r\n\t.st6{fill:#F23F44;}\r\n\t.st7{fill:#FF4F4F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3215_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3247_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3248_",
    className: "st0",
    d: "M93.9,39.1c0,0-8,1-11.6-11.6c-5-17.3-16.1-27-34.8-27s-29.8,9.7-34.8,27 C9.1,40.1,1.1,39.1,1.1,39.1s-4.3,9.7,5.8,15.5H3.1c0,0,2.3,11.7,14.2,13.3c1.5,3.4,6.2,7.9,20.6,7.9h9.7h9.7 c14.4,0,19.1-4.5,20.6-7.9c11.8-1.6,14.2-13.3,14.2-13.3h-3.9C98.2,48.8,93.9,39.1,93.9,39.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3245_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3246_",
    className: "st1",
    d: "M66.8,39.1C42.9,27,44.4,5.8,47.5,0.5c-18.7,0-29.8,9.7-34.8,27C9.1,40.1,1.1,39.1,1.1,39.1 s-4.3,9.7,5.8,15.5H3.1c0,0,2.3,11.7,14.2,13.3c1.5,3.4,6.2,7.9,20.6,7.9L66.8,39.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3244_",
    className: "st2",
    d: "M83.3,106l-2.2-16.6c-0.5-3.6-2.9-6.5-6.2-7.8l-13.1-4.8c-1.6-0.5-2.6-2-2.6-3.7v-6.2 l8.3-3.5c4.3-1.8,7.1-6,7.1-10.7v-1.9c3.2,0,5.8-2.6,5.8-5.8c0-3.2-2.6-5.8-5.8-5.8v-3.9c0-5.3-4.3-9.7-9.7-9.7H30.1 c-5.3,0-9.7,4.3-9.7,9.7v3.9c-3.2,0-5.8,2.6-5.8,5.8c0,3.2,2.6,5.8,5.8,5.8v1.9c0,4.7,2.8,8.9,7.1,10.7l8.3,3.5V73 c0,1.7-1.1,3.1-2.6,3.7l-13.1,4.8c-3.4,1.2-5.8,4.2-6.2,7.8L11.7,106c-0.5,3.5,2.2,6.6,5.7,6.6h30.1h30.1 C81.1,112.5,83.8,109.4,83.3,106z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3243_",
    className: "st3",
    d: "M35.9,66.9V73c0,1.4-0.7,2.6-1.9,3.3c15.4,2.7,24.2-8.4,25-9.5L35.9,66.9L35.9,66.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3242_",
    className: "st4",
    d: "M74.5,39.1v-3.9c0-5.3-4.3-9.7-9.7-9.7H30.1c-5.3,0-9.7,4.3-9.7,9.7v3.9 c-3.2,0-5.8,2.6-5.8,5.8c0,3.2,2.6,5.8,5.8,5.8v1.9c0,4.7,2.8,8.9,7.1,10.7l12.5,5.2c2.4,1,4.9,1.5,7.4,1.5l0,0 c2.6,0,5.1-0.5,7.4-1.5l12.5-5.2c4.3-1.8,7.1-6,7.1-10.7v-1.9c3.2,0,5.8-2.6,5.8-5.8C80.3,41.7,77.7,39.1,74.5,39.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3240_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3241_",
    className: "st5",
    d: "M34,46.8L34,46.8c-1.1,0-1.9-0.9-1.9-1.9V43c0-1.1,0.9-1.9,1.9-1.9l0,0 c1.1,0,1.9,0.9,1.9,1.9v1.9C35.9,46,35,46.8,34,46.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3237_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3238_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3239_",
    className: "st3",
    d: "M47.5,60.4c-3.4,0-6.6-0.8-8.8-2.3c-0.9-0.6-1.1-1.8-0.5-2.7c0.6-0.9,1.8-1.1,2.7-0.5 c1.5,1,4,1.6,6.6,1.6s5.1-0.6,6.6-1.6c0.9-0.6,2.1-0.4,2.7,0.5c0.6,0.9,0.4,2.1-0.5,2.7C54.1,59.6,50.9,60.4,47.5,60.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3233_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3235_",
    className: "st6",
    d: "M69.7,79.4l-7,11.1c-1.1,1.7-2.9,2.7-4.9,2.7H37.2c-2,0-3.9-1-4.9-2.7l-7-11.1 c-0.6-0.9-1.7-1.2-2.6-0.6l-6.3,3.8c-0.9,0.6-1.2,1.8-0.6,2.7L24.3,99h46.4l8.6-13.8c0.6-0.9,0.3-2.1-0.6-2.7l-6.3-3.8 C71.4,78.2,70.2,78.5,69.7,79.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3231_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3232_",
    x: 24.3,
    y: 99,
    className: "st7",
    width: 46.4,
    height: 13.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3230_",
    className: "st2",
    d: "M30.6,59.3c-1.6-1.7-2.4-3.9-2.4-6.2V32.7c6.7,4.7,16,8.4,33.3,9.4l-1.7-5.8 c0,0-12-6.8-17.9-10.6H30.1c-0.7,0-1.3,0.1-1.9,0.2v0c-0.1,0-0.3,0.1-0.4,0.1c0,0,0,0,0,0c0,0,0,0,0,0c-4.2,1.1-7.2,4.9-7.2,9.3 v3.9c-3.2,0-5.8,2.6-5.8,5.8c0,3.2,2.6,5.8,5.8,5.8v1.9c0,4.7,2.8,8.9,7.1,10.7l12.5,5.2c0.6,0.3,1.2,0.5,1.9,0.7 C36.4,65.2,32.7,61.6,30.6,59.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3222_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3225_",
    className: "st5",
    d: "M61,46.8L61,46.8c-1.1,0-1.9-0.9-1.9-1.9V43c0-1.1,0.9-1.9,1.9-1.9l0,0 c1.1,0,1.9,0.9,1.9,1.9v1.9C63,46,62.1,46.8,61,46.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3218_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3220_",
    className: "st0",
    d: "M66.8,39.1l-1.9-3.9c0,0,6.1,3.9,9.9,3.9V24.6H29.2C36.5,31.6,45.6,39.1,66.8,39.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3217_",
    className: "st1",
    d: "M66.8,39.1L66.8,39.1c-8.1-4.1-13.3-9.3-16.5-14.5H29.2C36.5,31.6,45.6,39.1,66.8,39.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_79_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_80_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_81_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_82_"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_83_"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_84_"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_85_"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_86_"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_87_"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_88_"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_89_"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_90_"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_91_"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_92_"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_93_"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarGirl);
export default __webpack_public_path__ + "static/media/avatar-girl.554799dca828a981a5dcd1bcc8ae1342.svg";
export { ForwardRef as ReactComponent };